import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';

import Page from 'components/Page';
import ListContent from 'components/ListContent';
import LoginRequired from 'components/LoginRequired';

import Loading from 'components/Loading';
import {withFilters, FILTERS} from 'components/withFilters';

import {
  selectAllocations,
  selectRoomsForRoomPurposesLoading,
  selectRoomPurposesTimelineData,
  fetchRoomsForRoomPurposes,
  selectRoomsForRoomPurposes,
  fetchRoomsForRoomPurposesWithoutFilters,
  selectRoomsForRoomPurposesWithoutFilters,
  selectRoomCheckbox,
  MODALS
} from 'ducks/allocations';
import {
  fetchRoomTypes,
  fetchFloors,
  selectFloors,
  fetchRoomTypeFilters,
  selectRoomTypeFilters
} from 'ducks/rooms';

import {isModalOpen, closeModal} from 'ducks/modals';

import {composeActions} from 'ducks/common';

import {
  PurposesCalendar,
  PurposesFilters,
  SubNavigation,
  AssignRoomPurposeModal,
  ConfirmAssignRoomPurposeModal
} from './components';
import {requiresPermission, PERMISSIONS} from 'ducks/auth';

import {ALLOCATIONS_URL} from 'config/urls';

import {reverse} from 'utils/urls';

import './styles.css';

const initialFilters = {
  search: '',
  roomTypes: [],
  rooms: [],
  floors: [],
  roomPurposeTypes: [],
  purposeEndDate: null,
  purposeStartDate: null,
  dummy: null,
  archived: false
};

class RoomPurposes extends React.Component<any> {
  state = {
    selectedRoomsIds: []
  };

  componentDidMount() {
    const {locationRef} = this.props.match.params;

    this.props.requiresPermission(
      {permission: PERMISSIONS.VIEW_ROOM_PURPOSES, locationRef},
      () => {
        this.props.fetchRoomTypes({locationRef});
        this.props.fetchFloors({locationRef});
        this.props.fetchRoomTypeFilters({locationRef});
        this.props.fetchRoomsForRoomPurposes({locationRef});
        // Fetching all rooms because we need them in Assign Purpose modal
        this.props.fetchRoomsForRoomPurposesWithoutFilters({locationRef});
      }
    );
  }

  selectRoom = (checked, roomId) => {
    const {selectedRoomsIds} = this.state;

    if (checked) {
      this.setState({
        selectedRoomsIds: [...selectedRoomsIds, roomId]
      });
      this.props.selectRoomCheckbox({roomId: roomId, isSelected: true});
    } else {
      this.setState({
        selectedRoomsIds: selectedRoomsIds.filter((id: any) => id !== roomId)
      });
      this.props.selectRoomCheckbox({roomId: roomId, isSelected: false});
    }
  };

  selectAllRooms = () => {
    const {groups} = this.props.roomPurposesTimelineData;

    this.setState({selectedRoomsIds: groups.map(group => group.roomId)});

    groups.map(group =>
      this.props.selectRoomCheckbox({roomId: group.roomId, isSelected: true})
    );
  };

  deselectAllRooms = () => {
    const {groups} = this.props.roomPurposesTimelineData;

    this.setState({selectedRoomsIds: []});

    groups.map(group =>
      this.props.selectRoomCheckbox({roomId: group.roomId, isSelected: false})
    );
  };

  deselectNumberOfRooms = rooms => {
    const {selectedRoomsIds} = this.state;
    const roomsIds = rooms.map(room => room.roomId);

    this.setState({
      selectedRoomsIds: selectedRoomsIds.filter(
        (id: any) => !roomsIds.includes(id)
      )
    });
    roomsIds.map(roomId => {
      this.props.selectRoomCheckbox({roomId: roomId, isSelected: false});
    });
  };

  setFilter = (field, value, withoutFetching = false) => {
    const {locationRef} = this.props.match.params;

    if (!withoutFetching) {
      this.props.composeActions([
        () => this.props.setFilter(field, value),
        () => fetchRoomsForRoomPurposes({locationRef})
      ]);
    } else {
      this.props.setFilter(field, value);
    }
  };

  clearFilters = () => {
    const {locationRef} = this.props.match.params;

    this.props.composeActions([
      () => this.props.clearFilters(),
      () => fetchRoomsForRoomPurposes({locationRef})
    ]);
  };

  redirectToRoomAllocations = () => {
    const {locationRef} = this.props.match.params;

    this.props.requiresPermission(
      {permission: PERMISSIONS.VIEW_ALLOCATIONS, locationRef},
      () => {
        this.props.history.push(
          reverse(ALLOCATIONS_URL, {
            locationRef
          })
        );
      }
    );
  };

  subNavigationWithData = props => (
    <SubNavigation
      {...props}
      toggleViewRenderer={this.props.toggleViewRenderer}
      selectedRoomsIds={this.state.selectedRoomsIds}
      redirectToRoomAllocations={this.redirectToRoomAllocations}
    />
  );

  render() {
    const {
      floors,
      roomPurposesTimelineData,
      roomTypeFilters,
      isLoading,
      assignRoomPurposeModal,
      confirmRoomPurposeModal,
      notFilteredRooms
    } = this.props;

    const {locationRef} = this.props.match.params;

    const filters = this.props.getFilters();
    const filterStartDate = _.get(filters, 'startDate.value');
    const filterEndDate = _.get(filters, 'endDate.value');
    const extraActions = [
      () => closeModal(MODALS.ASSIGN_ROOM_PURPOSE),
      () => fetchRoomsForRoomPurposes({locationRef})
    ];

    return (
      <Page activeTab="roomPurposes" locationRef={locationRef}>
        <ListContent
          className="RoomPurposes"
          filters={filters}
          initialFilters={initialFilters}
          setFilter={this.setFilter}
          navigationExtraElement={this.subNavigationWithData}>
          <ListContent.Content>
            <PurposesCalendar
              activeTab={this.props.activeTab}
              locationRef={locationRef}
              roomPurposesTimeline={roomPurposesTimelineData}
              filterStartDate={filterStartDate}
              filterEndDate={filterEndDate}
              changeCleaningStatus={this.props.changeCleaningStatus}
              selectAllRooms={this.selectAllRooms}
              deselectAllRooms={this.deselectAllRooms}
              selectRoom={this.selectRoom}
              selectedRoomsIds={this.state.selectedRoomsIds}
            />

            {isLoading && (
              <div className="loadingContainer">
                <Loading />
              </div>
            )}
          </ListContent.Content>
          <ListContent.Filters>
            <PurposesFilters
              locationRef={locationRef}
              rooms={notFilteredRooms}
              floors={floors}
              roomTypeFilters={roomTypeFilters}
              filters={filters}
              setFilter={this.setFilter}
              clearFilters={this.clearFilters}
            />
          </ListContent.Filters>
        </ListContent>
        {assignRoomPurposeModal && (
          <AssignRoomPurposeModal
            selectedRoomsIds={this.state.selectedRoomsIds}
            selectRoom={this.selectRoom}
            deselectNumberOfRooms={this.deselectNumberOfRooms}
            roomTypeFilters={roomTypeFilters}
            roomsForRoomPurposesDashboard={notFilteredRooms}
            locationRef={locationRef}
            extraActions={extraActions}
          />
        )}
        {confirmRoomPurposeModal && <ConfirmAssignRoomPurposeModal />}
      </Page>
    );
  }
}

const mapStateToProps = state => {
  return {
    allocations: selectAllocations(state),
    floors: selectFloors(state),
    isLoading: selectRoomsForRoomPurposesLoading(state),
    roomTypeFilters: selectRoomTypeFilters(state),
    roomsForRoomPurposesDashboard: selectRoomsForRoomPurposes(state),
    roomPurposesTimelineData: selectRoomPurposesTimelineData(state),
    assignRoomPurposeModal: isModalOpen(state, MODALS.ASSIGN_ROOM_PURPOSE),
    confirmRoomPurposeModal: isModalOpen(
      state,
      MODALS.CONFIRM_ASSIGN_ROOM_PURPOSE
    ),
    notFilteredRooms: selectRoomsForRoomPurposesWithoutFilters(state)
  };
};

const mapDispatchToProps = {
  selectRoomCheckbox,
  fetchRoomTypes,
  fetchFloors,
  requiresPermission,
  fetchRoomTypeFilters,
  composeActions,
  fetchRoomsForRoomPurposes,
  fetchRoomsForRoomPurposesWithoutFilters
};

export default connect(mapStateToProps, mapDispatchToProps)(
  withFilters(LoginRequired(RoomPurposes), FILTERS.PURPOSES_CALENDAR, {
    initialFilters
  })
);
